// extracted by mini-css-extract-plugin
export var buttons = "story-module--buttons--v0ZbY";
export var component = "story-module--component--4zjcq";
export var content = "story-module--content--QbU7m";
export var heading = "story-module--heading--hdhix";
export var icon = "story-module--icon--7B-W4";